import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { KPI } from "../../../../@core/api/models";
import { TranslateModule } from "@ngx-translate/core";
import { APIService } from "../../../../@core/api";
import { Subscription } from "rxjs";
import { UsersService, SaveToastService } from "../../../../@core/utils";

@Component({
  selector: "app-site-notes",
  standalone: true,
  imports: [TranslateModule, ReactiveFormsModule],
  templateUrl: "./site-notes.component.html",
  styleUrl: "./site-notes.component.scss"
})
export class SiteNotesComponent implements OnInit, OnDestroy {
  @Input({ required: true }) site!: KPI.Perimeter;
  private subscriptions: Subscription[] = [];

  public siteForm: FormGroup = this.fb.group({
    site_notes: []
  });
  public readOnly: boolean;

  constructor(
    private fb: FormBuilder,
    private apiService: APIService,
    private cdr: ChangeDetectorRef,
    private users: UsersService,
    private saveToast: SaveToastService
  ) {}

  ngOnInit() {
    this.siteForm.patchValue({ site_notes: this.site.site_notes });
    this.subscriptions.push(
      this.users.currentUserHasReadOnlyForSomePerimeters([this.site.id]).subscribe(
        readOnlyPermissions => {
          this.readOnly = readOnlyPermissions?.length > 0;
          if (this.readOnly) this.siteForm.disable();
        }
      )
    );
  }

  public cancelChanges(): void {
    this.siteForm.patchValue({ site_notes: this.site.site_notes });
    this.siteForm.markAsPristine();
  }

  private getUpdatedValues() {
    const updatedFormValues = {};
    this.siteForm["_forEachChild"]((control, name) => {
      if (control.dirty) {
        updatedFormValues[name] = control.value;
      }
    });
    return updatedFormValues;
  }

  public onSubmit() {
    const changedFields = this.getUpdatedValues();
    this.saveToast.showSaving();
    this.subscriptions.push(
      this.apiService.updateMultiPerimeter(this.site, changedFields).subscribe(
        (newSite) => {
          this.site.site_notes = newSite.site_notes;
          this.siteForm.markAsPristine();
          this.cdr.detectChanges();
          this.saveToast.showSaved();
        },
        (err) => {
          console.error(err);
          this.saveToast.close();
        }
      )
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
